import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Table } from 'reactstrap';

import { color } from '~/assets/styles/colors';
import { symbolPriceFormatter } from '~/helpers/price';
import { ModalAprovar } from '~/components/ModalSemNotas/AprovarPedido';
import { ModalVisualizarSN } from '~/components/ModalSemNotas/VisualizarPedido';

import { ButtonAprovar, TrStyled } from './styles';

export function Pedidos(props) {
	const { user,
		lancamentos,
		toggleAprovar,
		setToggleAprovar,
		toggleVisualizar,
		setToggleVisualizar,
		setMeusPedidos,
		pagina,
		filtroStatus,
		filtroPesquisa,
		filtroData
	} = props;

	const colorItem = {
		aprovado: color.green,
		reprovado: color.red,
		pendente: color.yellow,
		title: color.red,
	};
	const [numPedido, setNumPedido] = useState('');
	const [idPedido, setIdPedido] = useState('');
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 900); // Defina a largura de tela que considera como mobile
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<>
			<Table id="test-table-xls-button" responsive>
				<thead>
					<TrStyled>
						<th>Data</th>
						<th>Ref.Pedido</th>
						<th style={{ textAlign: 'left', paddingLeft: 22 }}>Solicitante</th>
						<th>Valor</th>
						<th>Status</th>
					</TrStyled>
				</thead>
				<tbody>
					{lancamentos.map((item, index) => {
						return (
							<tr style={{ textAlign: 'center' }} key={`${item.autorizacao}-${index}`}>
								<td>
									{moment(item.data_pedido).format(
										'DD/MM/YYYY'
									)}
								</td>
								<td style={{ textAlign: 'center' }}>{item.numero_pedido}</td>
								<td style={{ textAlign: 'left' }}>{item.nome}</td>
								<td>
									{symbolPriceFormatter(item.valor_pedido)}
								</td>
								<td
									style={{
										fontWeight: 'bold',
										textAlign: 'center',
										color: colorItem[
											item.status.toLowerCase()
										],
									}}>
									{item.status.toLowerCase() ===
										'pendente' ? (
										<ButtonAprovar
											style={{
												width: `${isMobile && '100%'}`,
												whiteSpace: `${isMobile && 'nowrap'}`,
												marginRight: `${isMobile && '12px'}`,
												textAlign: `${isMobile && 'center'}`,
											}}
											onClick={() => {
												setNumPedido(
													item.numero_pedido
												);
												setIdPedido(item.id);
												setToggleAprovar(
													!toggleAprovar
												);
											}}>
											Aprovação pendente
										</ButtonAprovar>
									) : (
										<>
											<button
												onClick={() => {
													setNumPedido(
														item.numero_pedido
													);
													setIdPedido(item.id);
													setToggleVisualizar(
														!toggleVisualizar
													);
												}}
												style={{ all: 'unset' }}
												type="button">
												{item.status.toLowerCase() ===
													'aprovado'
													? 'Aprovado'
													: 'Reprovado'}
											</button>
										</>
									)}
								</td>
							</tr>
						);
					})}
				</tbody>
			</Table>
			<ModalVisualizarSN
				user={user}
				idPedido={idPedido}
				numPedido={numPedido}
				tipo='recebidos'
				setToggle={setToggleVisualizar}
				toggle={toggleVisualizar}
			/>
			<ModalAprovar
				pagina={pagina}
				filtroData={filtroData}
				filtroPesquisa={filtroPesquisa}
				filtroStatus={filtroStatus}
				setMeusPedidos={setMeusPedidos}
				idPedido={idPedido}
				user={user}
				numPedido={numPedido}
				setToggle={setToggleAprovar}
				toggle={toggleAprovar}
			/>
		</>
	);
}
